import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { BsCheckCircleFill } from "react-icons/bs";
import { useUsuario } from "../context/UsuarioContext";
import { httpGet, httpPost } from "../http/request";

export default function RecibosPostulacionPendientes() {
  const { token } = useUsuario();
  const { pathname } = useLocation();
  const consultando = useRef(false);
  const revisarActual = useRef(() => {});
  const [pendientes, setPendientes] = useState([]);
  const [abriendo, setAbriendo] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setPendientes([]);
    setError("");
    if (!token) return;
    let activo = true;
    const revisar = async () => {
      if (document.visibilityState === "hidden" || consultando.current) return;
      consultando.current = true;
      try {
        const recibos = await httpGet("/api/v1/postulante/recibos/pendientes");
        if (activo && Array.isArray(recibos)) setPendientes(recibos);
      } finally {
        consultando.current = false;
      }
    };
    revisarActual.current = revisar;
    revisar();
    window.addEventListener("focus", revisar);
    window.addEventListener("pageshow", revisar);
    document.addEventListener("visibilitychange", revisar);
    return () => {
      activo = false;
      revisarActual.current = () => {};
      window.removeEventListener("focus", revisar);
      window.removeEventListener("pageshow", revisar);
      document.removeEventListener("visibilitychange", revisar);
    };
  }, [token]);

  useEffect(() => {
    revisarActual.current();
  }, [pathname]);

  const abrirRecibo = async () => {
    if (abriendo || !pendientes.length) return;
    const recibo = pendientes[0];
    setAbriendo(true);
    setError("");
    try {
      const confirmado = await httpPost({ codigo: recibo.codigo }, "/api/v1/postulante/recibos/abierto");
      if (confirmado) {
        // Navegar en esta pestaña permite ver el PDF sin depender de ventanas emergentes.
        window.location.assign(recibo.url);
      } else {
        setError("No se pudo abrir el recibo. Intenta nuevamente.");
      }
    } finally {
      setAbriendo(false);
    }
  };

  return (
    <Modal show={Boolean(token && pendientes.length)} onHide={() => setPendientes([])} centered backdrop="static" keyboard={!abriendo}>
      <Modal.Header closeButton={!abriendo}>
        <Modal.Title>Pago procesado correctamente</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <BsCheckCircleFill className="text-success mb-3" size={56} />
        <h5>¡Tu pago se procesó correctamente!</h5>
        <p className="text-muted mb-0">Tu recibo de pago de postulación está disponible. Pulsa el botón para verlo.</p>
        {error && <div className="alert alert-danger mt-3 mb-0" role="alert">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={abriendo} onClick={() => setPendientes([])}>Más tarde</Button>
        <Button variant="primary" disabled={abriendo} onClick={abrirRecibo}>
          {abriendo ? "Abriendo recibo…" : "Ver recibo de pago"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
